// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__R4AWl","header":"PatientQuestionnaire_header__lR2Vm","info":"PatientQuestionnaire_info__33Vsz"};